$( document ).ready(function() {
    setTimeout(function postData() {
        var iframeEl = document.getElementById('testFrame');
        var value = document.getElementById("statusCount").getAttribute("data-value");
        iframeEl.contentWindow.postMessage(value,"*");
    }, 100);
});

// Actualizar titulos
var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
var eventer = window[eventMethod];
var messageEvent = eventMethod == "attachEvent" ? "onmessage" : "message";
eventer(messageEvent, function (e) {
    
    setTimeout(function postData() {
        var iframeEl = document.getElementById('testFrame');
        var value = document.getElementById("statusCount").getAttribute("data-value");
        iframeEl.contentWindow.postMessage(value,"*");
        console.log("Enviado")
    }, 100);
    
    if (e.data == "1") {
        // Selecciono primero el elemento
        const element = document.getElementById("titlePopUp");

        // Creo un nuevo nodo de texto
        const newNode = document.createTextNode("Maneras de Acumular");

        // Remplazo el texto existente con el nuevo nodo
        element.replaceChild(newNode, element.childNodes[0]);
    } else if (e.data == "2") {

        const element = document.getElementById("titlePopUp");
        const newNode = document.createTextNode("Maneras de Redimir");

        element.replaceChild(newNode, element.childNodes[0]);

    } else if (e.data == "3") {
        const element = document.getElementById("titlePopUp");
        const newNode = document.createTextNode("Recomienda a tus amigos y obten puntos para seguir acumulando y redimir mas productos");

        element.replaceChild(newNode, element.childNodes[0]);
    } else if (e.data == "4") {
        const element = document.getElementById("titlePopUp");
        const newNode = document.createTextNode("Asciende y obten beneficios exclusivos");

        element.replaceChild(newNode, element.childNodes[0]);
    } else if (e.data == "5") {
        const element = document.getElementById("titlePopUp");
        const newNode = document.createTextNode("Nos encanta lo que haces por eso queremos que recibas muchos beneficios");

        element.replaceChild(newNode, element.childNodes[0]);

    } else if (e.data == "6") {
        const element = document.getElementById("titlePopUp");
        const newNode = document.createTextNode("Ganar puntos Escaneando el QR impreso en nuestro productos y redimelos");

        element.replaceChild(newNode, element.childNodes[0]);


    // Redirección de paginas
    } else if (e.data == "7") { // Para el boton "quiero ser parte del club"
        window.location.href = "/pages/registro-club";

    } else if (e.data == "8") { // Para el enlace "ingresa"
        window.location.href = "/account/login";
      
    } else if (e.data == "9") {
        window.location.href = "/pages/masgloprofessionalclub";
    }
}, false);


//Funciones al abrir PopUp
function openPopUp() {
    document.getElementById("myPopUp").style.display = "block";
    document.getElementById("openPopUp").style.display = "none";
    document.getElementById("downPopUp").style.display = "block";
}


//Funciones al cerrar PopUp
function closePopUp() {
    document.getElementById("myPopUp").style.display = "none";
    document.getElementById("openPopUp").style.display = "block";
    document.getElementById("downPopUp").style.display = "none";
}


// Obtener pagina correspondiente
function getPages(code) {
    window.parent.postMessage(menssage = code, "*");

    if (code == "1") {
        window.location.href = "AcumulaPopUp.html";
    } else if (code == "2") {
        window.location.href = "RedimirPopUp.html";
    } else if (code == "3") {
        window.location.href = "RecomiendaPopUp.html";
    } else if (code == "4") {
        window.location.href = "NivelesPopUp.html";
    } else if (code == "5") {
        window.location.href = "BeneficiosPopUp.html";
    } else if (code == "6") {
        window.location.href = "ClubPopUp.html";
    }
}